import { render, staticRenderFns } from "./ProductCategoryUpdate.vue?vue&type=template&id=c07124c2&scoped=true"
import script from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07124c2",
  null
  
)

export default component.exports